<div class="empty-state-wrapper simple-empty-state" [ngClass]="[alignmentClass, flexiblePlacementClass, rootCssClass]">
  <div data-automation-id="simple-empty-state-img" class="simple-empty-state-img" [ngClass]="simpleOption"></div>
  <div data-automation-id="simple-empty-state-caption" class="simple-empty-state-caption">{{ caption }}</div>
</div>
